<template>
  <div v-loading="loading" class="remove-preview-wrap">
    <iframe
      v-if="!hasLoadFail"
      class="preview-iframe"
      ref="previewFrame"
      frameborder="0"
      :src="minePreviewUrl"
    ></iframe>
    <no-authority
      v-if="hasLoadFail"
      :errorPromptType="errorPromptType"
      :isConfirmPasswordBtnLoading="isConfirmPasswordBtnLoading"
      @onConfirmPassword="handleConfirmPassword"
    >
    </no-authority>
    <footer v-if="isPPT">
      <div>
        版权声明：您应尊重相关著作人合法权益，未经著作权人合法授权，不能违法上传、存储、分享他人作品
      </div>
      <div>本内容由用户通过<span class="app">MAXHUB文档</span>发布，并不代表视臻公司立场</div>
    </footer>
  </div>
</template>

<script>
import { AIRDISK } from '@services';
import { Common } from '@utils';
import Vue from 'vue';
import { shell } from 'electron';
export default {
  name: 'RemoteDocPreview',
  data() {
    return {
      minePreviewUrl: '',
      loading: true,
      hasLoadFail: false,
      errorPromptType: 'loadFail',
      isConfirmPasswordBtnLoading: false
    };
  },
  props: {
    item: {
      Type: Object,
      default: () => {}
    },
    user: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    if (this.item.contentType === 'mhb' || this.item.contentType === 'record') {
      this.previewMhbFile();
    } else if (this.item.contentType === 'mhe') {
      this.previewMheFile();
    } else {
      this.previewOfficeFile();
    }
  },
  computed: {
    isPPT() {
      return this.item.contentType && ['ppt', 'pptx'].includes(this.item.contentType.toLowerCase());
    }
  },
  methods: {
    previewMhbFile() {
      const previewUrl = `${process.env.VUE_APP_SERVER_URL}/bff/mhb-preview?itemId=${this.item.itemId}&noHeader&noTips&hasStatement`;
      this.minePreviewUrl = previewUrl;
      this.loading = false;
    },
    previewMheFile() {
      this.$pushData('WEB_LOAD_MHE', { source: 'share' });
      let previewUrl;
      if (this.user.userId) previewUrl = `${process.env.VUE_APP_MHE_URL}?fileId=${this.item.itemId}`;
      else previewUrl = `${process.env.VUE_APP_MHE_URL}?fileId=${this.item.itemId}&previewMode=true`;
      this.minePreviewUrl = previewUrl;
      this.loading = false;

      window.addEventListener('message', ({ data, source }) => {
        if (data && typeof data === 'object' && Reflect.has(data, 'type')) {
          if (data.type === 'mhe-preview-loading') {
            this.loading = data.status;
          } else if (data.type === 'mhe-file-open-link') {
            try {
              shell.openExternal(data.link);
              // console.log('打开链接...1', data.link);
            } catch (error) {
              window.open(data.link);
              // console.log('打开链接...2', data.link);
            }
          }
        }
      });
    },
    previewOfficeFile(password) {
      const HD = ['ppt', 'pptx', 'doc', 'docx', 'pdf'];
      const isHD = Number(HD.includes(this.item.contentType));
      const isAsync = this.item.contentType === 'ppt' || this.item.contentType === 'pptx' ? 0 : 1;
      const params = {
        fileName: this.item.name,
        itemId: this.item.itemId,
        viewType: 0,
        isAsync: isAsync,
        isHD: isHD,
        uid: `${this.item.itemId}_${isHD}_${isAsync}`
      };
      if (password !== undefined) {
        params.password = password;
      }
      AIRDISK.Airdisk.getFilePreview(params)
        .then(res => {
          this.isConfirmPasswordBtnLoading = false;
          this.hasLoadFail = false;
          // 1. 判断url类型，是源预览地址还是cstore之后的地址
          const previewUrl = res.data.url;
          let minePerviewUrl = '';
          if (previewUrl.includes('/convert') || previewUrl.includes('/dcs-web')) {
            // 源地址，去掉域名，加上path
            minePerviewUrl = '/odviwer' + previewUrl.replace(/(http|https):\/\/[a-zA-Z0-9\-.]+/, '');
            minePerviewUrl = `${process.env.VUE_APP_SERVER_URL}${minePerviewUrl}?type=${this.item.contentType}`;
          } else {
            // cstore地址，去掉域名，加path，加type，加文件地址
            minePerviewUrl = '/seewo-odviwer' + previewUrl.replace(/(http|https):\/\/[a-zA-Z0-9\-.]+/, '');
            minePerviewUrl = `${process.env.VUE_APP_SERVER_URL}${minePerviewUrl}?src=${encodeURIComponent(
              previewUrl
            )}&type=${this.item.contentType}`;
          }
          this.minePreviewUrl = minePerviewUrl;

          setTimeout(() => {
            this.$refs['previewFrame'].focus();
          }, 2000);

          // 成功预览埋点
          this.$pushData('LOADED_PREVIEW_FILE', {
            format: Common.getFileFormat(this.item.name),
            fileSize: this.item.size
          });
        })
        .catch(err => {
          const response = err.response;
          const status = err?.response?.status;
          const code = err?.response?.data?.code;
          this.isConfirmPasswordBtnLoading = false;
          if (response && status === 403) {
            if (code === 4031013) {
              this.toast('密码错误，请重新输入密码');
            } else {
              this.loading = false;
              this.hasLoadFail = true;
              this.errorPromptType = 'encryption';
              if (code === 4031012) {
                this.errorPromptType = 'needPassword';
              } else if (code !== 4031005) {
                this.toast('文件加载失败，请检查!');
              }
            }
          } else {
            this.toast('请求网络超时，请重新尝试！');
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        });
    },
    handleConfirmPassword(password) {
      this.isConfirmPasswordBtnLoading = true;
      this.previewOfficeFile(Common.rsaEncrypt(password));
    }
  }
};
</script>

<style lang="scss" scoped>
@import './RemoteDocPreview';
</style>
